export const REGISTER_SUCCESSFUL = 'REGISTER_SUCCESSFUL';
export const REGISTER_ERROR = 'REGISTER_ERROR';
export const GET_USER = 'GET_USER';
export const LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CERRAR_SESION = 'CERRAR_SESION';
export const LOADING_USER = 'LOADING_USER';

export const ADD_PACIENTE = 'ADD_PACIENTE';
export const GET_PACIENTE = 'GET_PACIENTE';
export const EDIT_PACIENTE = 'EDIT_PACIENTE';
export const SELECT_PACIENTE = 'SELECT_PACIENTE';
export const ERROR_PACIENTE = 'ERROR_PACIENTE';
export const CLEAR_PACIENTE = 'CLEAR_PACIENTE';
export const LOADING_PACIENTE = 'LOADING_PACIENTE';

export const LOADING_CH = 'LOADING_CH';
export const GET_CLINIC_HISTORY = 'GET_CLINIC_HISTORY';
export const DELETE_CLINIC_HISTORY = 'DELETE_CLINIC_HISTORY';

export const ADD_ACTIVITY = 'ADD_ACTIVITY';
export const GET_ACTIVITY = 'GET_ACTIVITY';

export const ADD_DIAGNOSTIC = 'ADD_DIAGNOSTIC';
export const GET_DIAGNOSTIC = 'GET_DIAGNOSTIC';

export const ADD_CURB65 = 'ADD_CURB65';
export const GET_CURB65 = 'GET_CURB65';

export const ADD_HISOPADO = 'ADD_HISOPADO';
export const UPDATE_HISOPADO = 'UPDATE_HISOPADO';
export const GET_HISOPADO = 'GET_HISOPADO';

export const ADD_MEDICAL_HISTORY = 'ADD_MEDICAL_HISTORY';
export const GET_MEDICAL_HISTORY = 'GET_MEDICAL_HISTORY';
export const EDIT_MEDICAL_HISTORY = 'EDIT_MEDICAL_HISTORY';

export const ADD_NEWS2 = 'ADD_NEWS2';
export const GET_NEWS2 = 'GET_NEWS2';

export const ADD_PHYSICAL_EXAM = 'ADD_PHYSICAL_EXAM';
export const GET_PHYSICAL_EXAM = 'GET_PHYSICAL_EXAM';

export const ADD_TREATMENT = 'ADD_TREATMENT';
export const GET_TREATMENT = 'GET_TREATMENT';

export const ADD_HISTORY_CURRENT = 'ADD_HISTORY_CURRENT';
export const GET_HISTORY_CURRENT = 'GET_HISTORY_CURRENT';

export const ADD_APACHE = 'ADD_APACHE';
export const GET_APACHE = 'GET_APACHE';

export const ADD_SOFA = 'ADD_SOFA';
export const GET_SOFA = 'GET_SOFA';

export const GET_NURSING = 'GET_NURSING';
export const DELETE_NURSING = 'DELETE_NURSING';
export const ADD_NURSING_EXAM = 'ADD_NURSING_EXAM';
export const GET_NURSING_EXAM = 'GET_NURSING_EXAM';

export const ADD_ARM_EXAM = 'ADD_ARM_EXAM';
export const GET_ARM_EXAM = 'GET_ARM_EXAM';

export const ADD_APPLICATION = 'ADD_APPLICATION';
export const GET_APPLICATION = 'GET_APPLICATION';

export const ADD_BALANCE_EXAM = 'ADD_BALANCE_EXAM';
export const GET_BALANCE_EXAM = 'GET_BALANCE_EXAM';

export const GET_BED_OCCUPIED = 'GET_BED_OCCUPIED';
export const GET_BED_UNOCCUPIED = 'GET_BED_UNOCCUPIED';
export const OCCUPY_BED = 'OCCUPY_BED';
export const EMPTY_BED = 'EMPTY_BED';
export const SELECT_BED = 'SELECT_BED';
export const ERROR_BED = 'ERROR_BED';

export const ADD_MENTAL_QUERY = 'ADD_MENTAL_QUERY';
export const GET_MENTAL_QUERY = 'GET_MENTAL_QUERY';
export const SELECT_MENTAL_QUERY = 'SELECT_MENTAL_QUERY';
export const EDIT_MENTAL_QUERY = 'EDIT_MENTAL_QUERY';
export const ADD_MENTAL_EVOLUTION = 'ADD_MENTAL_EVOLUTION';
export const GET_MENTAL_EVOLUTION = 'GET_MENTAL_EVOLUTION';
export const LOADING_MENTAL = 'LOADING_MENTAL';
export const ERROR_MENTAL = 'ERROR_MENTAL';

export const ADD_ORDER_RX = 'ADD_ORDER_RX';
export const GET_ORDER = 'GET_ORDER';
export const GET_ORDER_PACIENTE = 'GET_ORDER_PACIENTE';
export const EDIT_ORDER = 'EDIT_ORDER';
export const ADD_REPORT = 'ADD_REPORT';
export const GET_REPORT_ORDER = 'GET_REPORT_ORDER';
export const LOADING_RX = 'LOADING_RX';
export const ERROR_RX = 'ERROR_RX';

export const GET_KINESIOLOGY = 'GET_KINESIOLOGY';
export const ADD_EVOLUTION_KINE = 'ADD_EVOLUTION_KINE';
export const GET_EVOLUTION_KINE = 'GET_EVOLUTION_KINE';
export const ADD_EVOLUTION_MV_KINE = 'ADD_EVOLUTION_MV_KINE';
export const GET_EVOLUTION_MV_KINE = 'GET_EVOLUTION_MV_KINE';

export const ADD_EVOLUTION_NUTR = 'ADD_EVOLUTION_NUTR';
export const GET_EVOLUTION_NUTR = 'GET_EVOLUTION_NUTR';

export const ADD_REPORT_LAB = 'ADD_EVOLUTION_LAB';
export const GET_REPORT_LAB = 'GET_EVOLUTION_LAB';
export const LOADING_LAB = 'LOADING_LAB';
export const ERROR_LAB = 'ERROR_LAB';

export const ADD_APPLICATION_HEMO = 'ADD_APPLICATION_HEMO';
export const GET_APPLICATION_HEMO = 'GET_APPLICATION_HEMO';

export const GET_ACTIVITY_FROM_TO = 'GET_ACTIVITY_FROM_TO';
export const LOADING_STATISTICS = 'LOADING_STATISTICS';
export const ERROR_STATISTICS = 'ERROR_STATISTICS';

export const RESTART_MESSAGE = 'RESTART_MESSAGE';
